import { render, staticRenderFns } from "./media-card.vue?vue&type=template&id=2126415a&scoped=true&"
import script from "./media-card.vue?vue&type=script&lang=js&"
export * from "./media-card.vue?vue&type=script&lang=js&"
import style0 from "./media-card.vue?vue&type=style&index=0&lang=css&"
import style1 from "./media-card.vue?vue&type=style&index=1&id=2126415a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2126415a",
  null
  
)

export default component.exports